/**
 * Rate Limit Module
 * Handles limiting the amount of traffic that an ad position is served to
 * version 2.0.4
 * 
 * Using Semantic Versioning, please update accordingly to keep files in sync across code bases
 * 
 * Given a version number MAJOR.MINOR.PATCH, increment the:
 *  1. MAJOR version when you implement a full re-build of the architecture,
 *  2. MINOR version when you add functionality, and
 *  3. PATCH version when you implement bug fixes or make small  tweaks to current functionality.
 */
define('AdModules/ratelimit',[
    "jquery",
    "logging",
    "storage"
], function ($, logging, storage) {
    "use strict";

    var _ModuleName = "DFP Rate Limit Module";
    var _config = {}
    var _data = {
        records: []
    }

    /**
     * Get configuration data off config object
     * @param {Config} config Configuration object
     */
    var init = function (config) {
        $.extend(_config, config.ratelimit);
    }

    /**
     * Start rate limit module
     */
    var start = function () {
        _printRateLimitResults();
    }


    /**
     * Checks if a given ad slot can serve to the current user. 
     * @param {AdSlot} slot Ad slot object
     */
    var canServe = function (slot) {
        // If limits are disabled, return true
        if (typeof _config.enabled == 'undefined' || _config.enabled === false) return true;

        // If limit not set, or set to 100%, return true 
        if (typeof slot.limit == 'undefined' || (slot.limit && slot.limit == 1.0)) return true;

        // If limit is set to 0, it was simply not set so return true
        if (slot.limit == 0.0) return true;

        ;

        // If invalid value for limit setting is passed, don't display slot at all
        if (slot.limit < 0 || slot.limit > 1.0) {
            logging.error("Invalid Slot Display Limit " + slot.limit + ". Should be a value between 0.0 and 1.0, inclusive.", _ModuleName);
            return false;
        }

        // Otherwise, calculate whether to display
        var sname = _getUniqueName(slot);

        // First check storage to see if it was previously calculated
        var result;
        if (_config.storage.enabled) {
            result = storage.getSessionStorage(sname);
            if (typeof result == 'boolean') {
                // Record the Rate Limited Slot Result
                _recordRateLimitedSlot(slot, result);

                ;
                return result;
            }
        }

        // If not, calculate
        result = Math.random() < slot.limit;

        // Store result
        if (_config.storage.enabled) {
            storage.setSessionStorage(sname, result);
        }

        if (_config.storage.enabled) {
            ;
        } else {
            ;
        }

        // Record the Rate Limited Slot Result
        _recordRateLimitedSlot(slot, result);

        // return result;
        return result;
    }

    /**
     * Disables this module
     */
    var disableStorage = function () {
        _config.storage.enabled = false;
    }

    /**
     * Checks if a slot was served
     * @param {String} position position value of the slot you're checking on
     */
    var wasServed = function (position) {
        // Check if the position has a rate limit record
        var record = _data.records.find(function (r) { return r.position = position; });
        // If nothing was recorded, then we don't know if it was served so return false
        if (typeof record == 'undefined') return false;
        // Return the display record for the position
        return record.display;
    }

    /**
     * Gets a unique storage name specific to this ad slot
     * @param {AdSlot} slot Ad slot object
     */
    var _getUniqueName = function (slot) {
        return _config.storage.limit + slot.position.toLowerCase().replace("_", "-");
    }

    var _recordRateLimitedSlot = function (slot, result) {
        var record = _data.records.find(function (r) { return r.position = slot.position; });
        if (typeof record == 'undefined') {
            _data.records.push({
                position: slot.position,
                display: result
            });
        } else {
            record.display = result;
        }
    }

    var _printRateLimitResults = function () {
        console.log("Rate Limit Results: %o", _data.records);
    }

    return {
        init: init,
        start: start,
        canServe: canServe,
        wasServed: wasServed,
        disableStorage: disableStorage,
        enabled: (function () { return _config.enabled; })
    }
});
